import React, { useEffect, useState } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Icons } from "../../constants/leagueLockerConfig";
import { useOutletContext } from "react-router";
import { getLeagueBySlug } from "./firestoreQuery";
import { LeagueContext } from "../../pages/LeagueLockerPage";
import { SectionLoader } from "../ui/SectionLoader";

const LeagueLockerAboutSection = React.forwardRef<HTMLDivElement>(() => {
  const { leagueUrl } = useOutletContext<LeagueContext>();
  const [leagueData, setLeagueData] = useState<any>({});
  const [isLoading, setIsLoading] = useState(true);

  const fetchLeagueDetails = async () => {
    try {
      // Fetch league details logic here
      setIsLoading(true);
      const res = await getLeagueBySlug(leagueUrl || "");
      setLeagueData(res);
    } catch (error) {
      console.error("Error fetching league:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLeagueDetails();
  }, [leagueUrl]);

  if (isLoading) {
    return <SectionLoader />;
  }

  return (
    <div className="sectionBlk">
      <>
        <div className="shadowBlk">
          <div className="blkHeading">📖 About This League</div>
          <div className="prose">
            <Markdown remarkPlugins={[remarkGfm]}>
              {leagueData?.description && leagueData.description.length > 1
                ? leagueData.description
                : "Not Listed"}
            </Markdown>
          </div>
        </div>
        <div className="shadowBlk">
          <div className="leagueBottom">
            <div className="bottomItem">
              <label htmlFor="">League Size</label>
              <span className="itemTxt">{leagueData?.leagueSize} Teams</span>
            </div>
            <div className="bottomItem">
              <label htmlFor="">Hosted On</label>
              {leagueData?.platform && leagueData?.platform !== "Not Listed" ? (
                <span className="itemTxt">
                  {Icons[leagueData?.platform as keyof typeof Icons]}{" "}
                </span>
              ) : (
                <span className="itemTxt">Not Listed</span>
              )}
            </div>
          </div>
        </div>
        <div className="shadowBlk">
          <div className="blkHeading">🗓️ Season Setup</div>
          <div className="prose">
            <Markdown remarkPlugins={[remarkGfm]}>
              {leagueData?.leagueRules?.seasonStartup.length > 1
                ? leagueData?.leagueRules?.seasonStartup
                : "Not Listed"}
            </Markdown>
          </div>
        </div>
        <div className="shadowBlk">
          <div className="blkHeading">🫡 Draft Day</div>
          <div className="prose">
            <Markdown remarkPlugins={[remarkGfm]}>
              {leagueData?.leagueRules?.draftDay.length > 1
                ? leagueData?.leagueRules?.draftDay
                : "Not Listed"}
            </Markdown>
          </div>
        </div>
        <div className="shadowBlk">
          <div className="blkHeading">🏈 Scoring</div>
          <div className="prose">
            <Markdown remarkPlugins={[remarkGfm]}>
              {leagueData?.leagueRules?.scoring.length > 1
                ? leagueData?.leagueRules?.scoring
                : "Not Listed"}
            </Markdown>
          </div>
        </div>
        <div className="shadowBlk">
          <div className="blkHeading">📝 Waivers & Free Agency</div>
          <div className="prose">
            <Markdown remarkPlugins={[remarkGfm]}>
              {leagueData?.leagueRules?.waiversAndFreeAgency.length > 1
                ? leagueData?.leagueRules?.waiversAndFreeAgency
                : "Not Listed"}
            </Markdown>
          </div>
        </div>
        <div className="shadowBlk">
          <div className="blkHeading">🔁 Trades</div>
          <div className="prose">
            <Markdown remarkPlugins={[remarkGfm]}>
              {leagueData?.leagueRules?.trades.length > 1
                ? leagueData?.leagueRules?.trades
                : "Not Listed"}
            </Markdown>
          </div>
        </div>
        <div className="shadowBlk">
          <div className="blkHeading">✍️ Additional Details</div>
          <div className="prose">
            <Markdown remarkPlugins={[remarkGfm]}>
              {leagueData?.leagueRules?.leagueAdditionalDetails.length > 1
                ? leagueData?.leagueRules?.leagueAdditionalDetails
                : "Not Listed"}
            </Markdown>
          </div>
        </div>
      </>
    </div>
  );
});

export default LeagueLockerAboutSection;
